var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.globalErrors)?_c('div',{staticClass:"schema-global-errors"},_vm._l((_vm.globalErrors),function(errorlist,index){return _c('div',{key:index,staticClass:"controls"},_vm._l((errorlist),function(error,indx){return _c('div',{key:indx,staticClass:"text-error"},[_vm._v(_vm._s(error))])}),0)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }